<template>
  <div>
    <div class="box box-primary color-palette-box mb-0">
      <VueApexCharts
        ref="apexcharts"
        type="line"
        height="450px"
        :options="options"
        :series="formatData"
      />
    </div>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import moment from 'moment';

export default {
  props: [
    "feedback",
    "messages",
    "loading",
    "refreshTrigger" // HACK: to refresh send new date
  ],
  name: "MessagesChart",
  components: {
    VueApexCharts
  },
  data() {
    return {
      options: {
        chart: {
          id: "line-chart",
          fontFamily: 'Spartan, sans-serif',
          shadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 1
          },
          toolbar: {
            show: false
          }
        },
        colors: ["#128ff9", "#44e5e7"],
        stroke: { curve: "straight" },
        xaxis: {
          categories: []
        },
        dataLabels: {
          enabled: true,
          background: {
            enabled:false
          },
          offsetY: -5,
        },
        title: {
          text: "surveys sent and received",
          align: "left"
        },
        grid: {
          yaxis: {
            lines: {
              show: false
             }
           }
        },
        markers: {
          size: 2
        },
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: 225,
          offsetX: -5
        }, 
      },
      series: [
        {
          name: "surveys sent",
          data: []
        },
        {
          name: "feedback received",
          data: []
        }
      ]
    }
  },
  computed: {
    formatData: function() {
      this.setChartData(this.messages, 0);
      this.setChartData(this.feedback, 1);

      return this.series;
    }
  },
  methods: {
    setChartData(data, index) {
      if (data.length > 0) {
        const chartData = data.map(item => {
          return {
            x: moment(item.date, "YYYY-MM-DD").format("MMM,Do").toLowerCase(),
            y: item.count
          };
        });

        if (chartData.length > 0) {
          this.series[index].data = chartData;
        }
      }
    }
  },
  watch: {
    refreshTrigger: function(newVal, oldVal) {
      if (!this.$refs.apexcharts) return false;
      this.formatData;
      this.$refs.apexcharts.refresh();

    }
  },
};
</script>